import { Table } from 'antd';

const ProductTableColumns = [
  {
    title: 'سایز',
    dataIndex: 'size',
    key: 'size',
    align: 'center',
  },
  {
    title: 'عرض لباس (cm)',
    dataIndex: 'width',
    key: 'width',
    align: 'center',
  },
  {
    title: 'قد لباس (cm)',
    dataIndex: 'height',
    key: 'height',
    align: 'center',
  },
  {
    title: 'قد آستین (cm)',
    key: 'armlength',
    dataIndex: 'armlength',
    align: 'center',
  },
 
];

const MenTShirtTableData = [
  {
    key: '1',
    size: 'S',
    width: 52,
    height: 68,
    armlength: 22.5,
  },
  {
    key: '2',
    size: 'M',
    width: 54,
    height: 70,
    armlength: 24,
  },
  {
    key: '3',
    size: 'L',
    width: 56,
    height: 72,
    armlength: 25,
  },
  {
    key: '4',
    size: 'XL',
    width: 59,
    height: 74,
    armlength: 27,
  },
  {
    key: '5',
    size: '2XL',
    width: 62,
    height: 76,
    armlength: 29,
  },
  {
    key: '6',
    size: '3XL',
    width: 65,
    height: 77,
    armlength: 31,
  },
  {
    key: '7',
    size: '4XL',
    width: 71,
    height: 80,
    armlength: 33,
  },
  {
    key: '8',
    size: '5XL',
    width: 71,
    height: 81,
    armlength: 35,
  },
  
];

const MenCollarTShirtTableData = [
  {
    key: '1',
    size: 'S',
    width: 52,
    height: 68,
    armlength: 22.5,
  },
  {
    key: '2',
    size: 'M',
    width: 54,
    height: 70,
    armlength: 24,
  },
  {
    key: '3',
    size: 'L',
    width: 56,
    height: 72,
    armlength: 25,
  },
  {
    key: '4',
    size: 'XL',
    width: 59,
    height: 74,
    armlength: 27,
  },
  {
    key: '5',
    size: '2XL',
    width: 62,
    height: 76,
    armlength: 29,
  },
  {
    key: '6',
    size: '3XL',
    width: 65,
    height: 77,
    armlength: 31,
  },
  {
    key: '7',
    size: '4XL',
    width: 71,
    height: 80,
    armlength: 33,
  },
  {
    key: '8',
    size: '5XL',
    width: 71,
    height: 81,
    armlength: 35,
  },
  
];

const MenShirtTableData = [
  {
    key: '1',
    size: 'S',
    width: 55,
    height: 72,
    armlength: 67,
  },
  {
    key: '2',
    size: 'M',
    width: 57,
    height: 74,
    armlength: 68.5,
  },
  {
    key: '3',
    size: 'L',
    width: 59,
    height: 76,
    armlength: 70,
  },
  {
    key: '4',
    size: 'XL',
    width: 62,
    height: 78,
    armlength: 71.5,
  },
  {
    key: '5',
    size: '2XL',
    width: 65,
    height: 80,
    armlength: 73,
  },
  {
    key: '6',
    size: '3XL',
    width: 68,
    height: 81,
    armlength: 75,
  },
  {
    key: '7',
    size: '4XL',
    width: 71,
    height: 82,
    armlength: 76.5,
  },
  {
    key: '8',
    size: '5XL',
    width: 74,
    height: 83,
    armlength: 78,
  },
  
];

const MenHoodieTableData = [
  {
    key: '1',
    size: 'S',
    width: 55,
    height: 71,
    armlength: 65,
  },
  {
    key: '2',
    size: 'M',
    width: 57,
    height: 73,
    armlength: 67,
  },
  {
    key: '3',
    size: 'L',
    width: 59,
    height: 75,
    armlength: 69,
  },
  {
    key: '4',
    size: 'XL',
    width: 62,
    height: 77,
    armlength: 71,
  },
  {
    key: '5',
    size: '2XL',
    width: 65,
    height: 79,
    armlength: 73,
  },
  {
    key: '6',
    size: '3XL',
    width: 68,
    height: 80,
    armlength: 75,
  },
  {
    key: '7',
    size: '4XL',
    width: 71,
    height: 81,
    armlength: 76,
  },
  {
    key: '8',
    size: '5XL',
    width: 74,
    height: 82,
    armlength: 76.5,
  },
  
];

const WomenTShirtTableData = [
  {
    key: '1',
    size: 'S',
    width: 44,
    height: 58,
    armlength: 15,
  },
  {
    key: '2',
    size: 'M',
    width: 46,
    height: 60,
    armlength: 16,
  },
  {
    key: '3',
    size: 'L',
    width: 48,
    height: 62,
    armlength: 17,
  },
  {
    key: '4',
    size: 'XL',
    width: 50,
    height: 64,
    armlength: 18,
  },
  {
    key: '5',
    size: '2XL',
    width: 52,
    height: 66,
    armlength: 19,
  },
  {
    key: '6',
    size: '3XL',
    width: 54,
    height: 68,
    armlength: 20,
  },
  {
    key: '7',
    size: '4XL',
    width: 56,
    height: 70,
    armlength: 23,
  },
  {
    key: '8',
    size: '5XL',
    width: 58,
    height: 72,
    armlength: 24,
  },
  
];

const WomenCollarTShirtTableData = [
  {
    key: '1',
    size: 'S',
    width: 44,
    height: 58,
    armlength: 15,
  },
  {
    key: '2',
    size: 'M',
    width: 46,
    height: 60,
    armlength: 16,
  },
  {
    key: '3',
    size: 'L',
    width: 48,
    height: 62,
    armlength: 17,
  },
  {
    key: '4',
    size: 'XL',
    width: 50,
    height: 64,
    armlength: 18,
  },
  {
    key: '5',
    size: '2XL',
    width: 52,
    height: 66,
    armlength: 19,
  },
  {
    key: '6',
    size: '3XL',
    width: 54,
    height: 68,
    armlength: 20,
  },
  {
    key: '7',
    size: '4XL',
    width: 56,
    height: 70,
    armlength: 23,
  },
  {
    key: '8',
    size: '5XL',
    width: 58,
    height: 72,
    armlength: 24,
  },
  
];

const WomenCropTShirtTableData = [
  {
    key: '1',
    size: 'S',
    width: 53,
    height: 43,
    armlength: 19,
  },
  {
    key: '2',
    size: 'M',
    width: 55,
    height: 45,
    armlength: 20,
  },
  {
    key: '3',
    size: 'L',
    width: 57,
    height: 47,
    armlength: 21,
  },
  {
    key: '4',
    size: 'XL',
    width: 59,
    height: 49,
    armlength: 22,
  },
  {
    key: '5',
    size: '2XL',
    width: 61,
    height: 51,
    armlength: 23,
  },
  {
    key: '6',
    size: '3XL',
    width: 63,
    height: 53,
    armlength: 24,
  },
  {
    key: '7',
    size: '4XL',
    width: 65,
    height: 55,
    armlength: 25,
  },
  {
    key: '8',
    size: '5XL',
    width: 67,
    height: 57,
    armlength: 26,
  },
  
];

const KidTShirtTableData = [
  {
    key: '1',
    size: '6-8 سال',
    width: 41,
    height: 49,
    armlength: 18.5,
  },
  {
    key: '2',
    size: '9-10 سال',
    width: 43,
    height: 50,
    armlength: 22,
  },
  {
    key: '3',
    size: '11-12 سال',
    width: 45,
    height: 57,
    armlength: 25,
  },
  {
    key: '4',
    size: '13-14 سال',
    width: 48,
    height: 62,
    armlength: 30,
  },
  
];

const KidCollarTShirtTableData = [
  {
    key: '1',
    size: '6-8 سال',
    width: 41,
    height: 49,
    armlength: 18.5,
  },
  {
    key: '2',
    size: '9-10 سال',
    width: 43,
    height: 50,
    armlength: 22,
  },
  {
    key: '3',
    size: '11-12 سال',
    width: 45,
    height: 57,
    armlength: 25,
  },
  {
    key: '4',
    size: '13-14 سال',
    width: 48,
    height: 62,
    armlength: 30,
  },
  
];

const KidShirtTableData = [
  {
    key: '1',
    size: '6-8 سال',
    width: 44,
    height: 52,
    armlength: 48,
  },
  {
    key: '2',
    size: '9-10 سال',
    width: 46,
    height: 56,
    armlength: 53,
  },
  {
    key: '3',
    size: '11-12 سال',
    width: 48,
    height: 60,
    armlength: 58,
  },
  {
    key: '4',
    size: '13-14 سال',
    width: 50,
    height: 64,
    armlength: 63,
  },
  
];

const KidHoodieTableData = [
  {
    key: '1',
    size: '6-8 سال',
    width: 44,
    height: 52,
    armlength: 48,
  },
  {
    key: '2',
    size: '9-10 سال',
    width: 46,
    height: 56,
    armlength: 53,
  },
  {
    key: '3',
    size: '11-12 سال',
    width: 48,
    height: 60,
    armlength: 58,
  },
  {
    key: '4',
    size: '13-14 سال',
    width: 50,
    height: 64,
    armlength: 63,
  },
  
];

const MenTShirtSizeTable = ()=>{ return (<Table pagination={false} bordered={true} rowHoverable={false} columns={ProductTableColumns} dataSource={MenTShirtTableData} />)}
const MenCollarTShirtSizeTable = ()=>{ return (<Table pagination={false} bordered={true} rowHoverable={false} columns={ProductTableColumns} dataSource={MenCollarTShirtTableData} />)}
const MenShirtSizeTable = ()=>{ return (<Table pagination={false} bordered={true} rowHoverable={false} columns={ProductTableColumns} dataSource={MenShirtTableData} />)}
const MenHoodieSizeTable = ()=>{ return (<Table pagination={false} bordered={true} rowHoverable={false} columns={ProductTableColumns} dataSource={MenHoodieTableData} />)}
const WomenTShirtSizeTable = ()=>{ return (<Table pagination={false} bordered={true} rowHoverable={false} columns={ProductTableColumns} dataSource={WomenTShirtTableData} />)}
const WomenCollarTShirtSizeTable = ()=>{ return (<Table pagination={false} bordered={true} rowHoverable={false} columns={ProductTableColumns} dataSource={WomenCollarTShirtTableData} />)}
const WomenCropTShirtSizeTable = ()=>{ return (<Table pagination={false} bordered={true} rowHoverable={false} columns={ProductTableColumns} dataSource={WomenCropTShirtTableData} />)}
const KidTShirtSizeTable = ()=>{ return (<Table pagination={false} bordered={true} rowHoverable={false} columns={ProductTableColumns} dataSource={KidTShirtTableData} />)}
const KidCollarTShirtSizeTable = ()=>{ return (<Table pagination={false} bordered={true} rowHoverable={false} columns={ProductTableColumns} dataSource={KidCollarTShirtTableData} />)}
const KidShirtSizeTable = ()=>{ return (<Table pagination={false} bordered={true} rowHoverable={false} columns={ProductTableColumns} dataSource={KidShirtTableData} />)}
const KidHoodieSizeTable = ()=>{ return (<Table pagination={false} bordered={true} rowHoverable={false} columns={ProductTableColumns} dataSource={KidHoodieTableData} />)}


export {MenTShirtSizeTable, MenShirtSizeTable, MenHoodieSizeTable, WomenTShirtSizeTable, WomenCropTShirtSizeTable, MenCollarTShirtSizeTable, WomenCollarTShirtSizeTable,
   KidShirtSizeTable, KidTShirtSizeTable, KidCollarTShirtSizeTable, KidHoodieSizeTable}

